import { observer } from 'mobx-react-lite';
import { useField } from '../../../hooks';
import { FieldWrapper } from '../../../components';
import { SwitchInputProps } from './index';
import { SwitchMultiple } from '@apia/components';

export const Component = observer(
  <T extends string>({
    name,
    label,
    title,
    options,
    formName,
    initialValue,
    removeOnUnmount,
    validationFunction,
    validationRules,
    onChange: outerOnChange,
  }: SwitchInputProps<T>) => {
    const { value, onChange } = useField<T>({
      formName,
      name,
      initialValue,
      removeOnUnmount,
      validationFunction,
      validationRules,
    });

    return (
      <FieldWrapper name={name} label={label} title={title}>
        <SwitchMultiple
          defaultValue={initialValue}
          value={value}
          options={options}
          onChange={(ev) => {
            onChange(ev);
            outerOnChange && outerOnChange(ev);
          }}
        ></SwitchMultiple>
      </FieldWrapper>
    );
  },
);
